const styles = (theme) => ({
    headerImg: {
        marginBottom: "20px",
        width: "100%",
    },
});

export default styles;
